import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data/data.service';

import { MapService } from 'src/app/services/map/map.service';
import { OpenlayerService } from 'src/app/services/openlayer/openlayer.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LayerStoreService } from 'src/app/stores/layer-store/layer-store.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { PotreeCesiumToolType } from '../../potree-cesium-viewer/potree-cesium-viewer.component';
import { PotreeCesiumViewerService } from '../../potree-cesium-viewer/potree-cesium-viewer.service';

@Component({
  selector: 'app-toolkit-list',
  templateUrl: './toolkit-list.component.html',
  styleUrls: ['./toolkit-list.component.sass'],
})
export class ToolkitListComponent implements OnInit, OnDestroy {
  isDraw;
  mapServiceSub: Subscription;
  isOrtho: boolean;
  isThermal: boolean;
  isThreeD: boolean;
  isThreeDMesh: boolean;
  isEmbed: boolean;
  isGeojson: boolean;
  disableMapboxDraw: boolean = false;
  isFacade: boolean;
  openlayerDrawmode = 'None'

  constructor(
    private mapService: MapService,
    private dataService: DataService,
    private toastr: ToastrService,
    private router: Router,
    private potreeCesiumViewerService: PotreeCesiumViewerService,
    private splitViewService: SplitViewService,
    private _t: TranslateService,
    private locationStore: LocationStoreService,
    private layerStore: LayerStoreService,
    private openlayerService: OpenlayerService
  ) { }

  ngOnInit(): void {
    this.mapServiceSub = this.mapService.isDraw$.subscribe((res) => (this.isDraw = res));
    this.mapService.isOrtho$.subscribe((res) => {
      this.isOrtho = res;
    });
    this.mapService.isThermal$.subscribe((res) => {
      this.isThermal = res;
    });
    this.mapService.isThreeD$.subscribe((res) => {
      this.isThreeD = res;
    });
    this.mapService.isThreeDMesh$.subscribe((res) => {
      this.isThreeDMesh = res;
    });
    this.mapService.hasDrawing$.subscribe(res => this.disableMapboxDraw = res)
    this.layerStore.isFacade$
      .subscribe((res) => {
        if(res)
          this.isFacade = true
        else
          this.isFacade = false
      });
    
    this.openlayerService.drawMode$.subscribe(mode => {
      this.openlayerDrawmode = mode
    })
  }

  toggleDraw(mode) {
    if (this.disableMapboxDraw) { return; }

    if (this.locationStore.currentLocation.id) {
      this.mapService.toggleDraw(mode);
      if (!this.splitViewService.isEditingAnnotation)
        this.router.navigateByUrl(
          `projects/${this.locationStore.currentLocation.id}/details/annotations/create`
        );
    } else {
      this.toastr.error(this._t.instant('Invalid Action'), this._t.instant('Please enter a project'));
    }
  }

  deleteAnnotation() {
    if (this.isThreeD)
      this.potreeCesiumViewerService.removeAllMeasurements()
    else if (this.isFacade)
      this.openlayerService.deleteSelectedAnnot$.next(new Date().toISOString());
    else
      this.mapService.deleteSelectedAnnot();
  }

  arrayHasLayerType(array, layerType) {
    if (array.find((i) => i.layer_type === layerType)) return true
    else return false
  }

  ngOnDestroy() {
    this.mapServiceSub.unsubscribe()
  }

  activateTool(type: string) {

    this.mapService.isDraw$.next(type)
    switch (type) {
      case "measure-height":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureHeightTool);
        break;

      case "measure-distance":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureDistanceTool);
        break;

      case "measure-point":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasurePointTool);
        break;

      case "measure-angle":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureAngleTool);
        break;

      case "measure-circle":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureCircleTool);
        break;

      case "measure-area":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureAreaTool);
        break;

      case "measure-azimuth":
        this.potreeCesiumViewerService.activateTool(PotreeCesiumToolType.MeasureAzimuthTool);
        break;

      default:
        console.log("Invalid tool request..");
        break;
    }
    this.router.navigateByUrl(
      `projects/${this.locationStore.currentLocation.id}/details/annotations/create`
    );
  }

  olDrawMode(mode) {
    if (this.disableMapboxDraw) { return; }

    if (this.locationStore.currentLocation.id) {
      if (!this.splitViewService.isEditingAnnotation)
        this.router.navigateByUrl(
          `projects/${this.locationStore.currentLocation.id}/details/annotations/create`
        );
    } else {
      this.toastr.error(this._t.instant('Invalid Action'), this._t.instant('Please enter a project'));
    }

    if (mode === this.openlayerService.drawMode$.getValue())
      this.openlayerService.drawMode$.next('None')
    else
      this.openlayerService.drawMode$.next(mode)
  }
}
